import React from "react";
import styles from "./OperationRequestWorkspace.module.css";

/**
 * @param {{ header: React.ReactNode, sidebar: React.ReactNode, children: React.ReactNode }} props
 */
export default function OperationRequestLayout({ header, sidebar, children }) {
  return (
    <div className={styles.page} dir="rtl">
      <div className={styles.container}>
        <div className={styles.headerBar}>{header}</div>
        <div className={styles.grid}>
          <aside className={styles.sidebar}>{sidebar}</aside>
          <div className={styles.main}>
            <div className={styles.mainInner}>{children}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
